export default {"src":"/_next/static/media/intelligent_process_automation.0a1bcab4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};